<template>
  <tr class="search__result__form-buttons" v-if="filteredResults !== undefined && filteredResults.length > 0">
    <th colspan="3" class="search__result__form-buttons--resetbutton" scope="col">
      <button type="reset" @click="$parent.resetForm">Alle Filter leeren</button>
    </th>
    <th colspan="3" class="search__result__form-buttons--download" scope="col">
      <p v-if="totalPages > 0">
        Download:
        <select name="search__pdf-download__type" class="" v-model="$parent.pdfDownloadType">
          <option value="current">aktuelle Seite</option>
          <option value="search">gesamte Suche</option>
        </select>
        &nbsp;<a href="#" @click="$parent.downloadPdf">Speichern</a>
      </p>
    </th>
  </tr>
</template>

<script>
export default {
  name: 'SearchResultFormButtons',
  components: {
  },
  props: {
    filteredResults: Array,
    totalPages: Number
  }
}
</script>

<style lang="scss">
  .search__result__form-buttons {
    th {
      border-bottom: 1px solid black;
      padding: 0.5em 0;
    }
    .search__result__form-buttons--download p {
      float: right;
      margin: 0;
    }
  }
</style>
